export default __webpack_public_path__ + "static/cursor_down_2-b1fbf224c0768f2d54720a8aefd6dff0.png";